<template>
  <main id="pht-content-login">
    <div class="row">
      <div class="medium-6">
        <div class="image-background"  :style="`background-image: url(${backgroundImage})`"></div>
      </div>
      <div class="medium-6">
        <div class="box-login text-center">
          <div v-if="!email">
            <div class="align-self-top">
              <div class="medium-9 margin-x-auto">
                <img :src="globalConfig.logo" :alt="globalConfig.installationName" class="logo" />
                <router-view />
              </div>
            </div>
          </div>          
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import globalConfigMixin from 'shared/mixins/globalConfigMixin';
import { mapGetters } from 'vuex';


export default {
  components: {    
  },
  mixins: [globalConfigMixin],  
  computed: {
    ...mapGetters({
      globalConfig: 'globalConfig/get',
    }),    
    backgroundImage() {
      if(this.globalConfig.loginBackgroundImage && this.globalConfig.loginBackgroundImage.toString().trim() !== '') {
        return this.globalConfig.loginBackgroundImage;
      }
      return '/assets/images/auth/background-default.png';
    },
  },
  created() {    
  },
  methods: {    
  },
};
</script>
